import styled from "styled-components";

interface XrStepAvProps {
  title: string;
  order: number;
  step: string;
  activeStep: string;
  status: 'in-progress' | 'pending' | 'finished' | 'error';
  onClick: () => void;
}

const XrStepAv = (props: XrStepAvProps) => {
  return (
    <XrStepAvWrapper onClick={props.onClick} className={`${props.step === props.activeStep ? 'active' : ''}`}>
      <div className='button__number'>
        {props.order}
      </div>
      <div className='button__description'>
        <p>{props.title}</p>
      </div>
    </XrStepAvWrapper>
  );
}

const XrStepAvWrapper = styled.div<any>`
  width: 100%;
  display: flex;
  border-radius: 5px;
  margin-bottom: 15px;
  align-items: center;
  transition: 0.15s all;
  border: 1px solid #ECECEC;
  padding: 10px 15px 10px 15px;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.07);

  & .button__number {
    width: 35px;
    height: 35px;
    min-width: 35px;
    min-height: 35px;
    display: flex;
    font-size: 14px;
    color: #dddddd;
    margin-left: -33px;
    margin-right: 10px;
    align-items: center;
    border-radius: 999px;
    justify-content: center;
    background-color: #fff;
    border: 1px solid #ececec;
    transition: 0.15s all;
  }

  & .button__description {
    width: (100% - 40px);
    & > p {
      margin: 0;
      font-size: 14px;
      color: #363636;
      transition: 0.15s all;
    }
  }

  &.active {
    border-color: #00AD8C;
    & > .button__number {
      color: #00AD8C;
      font-weight: bold;
      border-color: #00AD8C;
    }
    & .button__description {
      & > p {
        color: #00AD8C;
        font-weight: bold;
      }
    }
  }
`;

export default XrStepAv;